import React, { useState } from "react";
import { Alert, AlertTitle, Container, Stack } from "@mui/material";
import { RadioGroup, Box, Typography } from "@mui/material";
import SubmitButton from "../common/SubmitButton";
import Backdrop from "../common/Backdrop";
import LoadingDots from "../Lottie/LoadingDots";
import Radio from "../Base/Radio/index";
import Input from "../Base/Input/index";
import configData from "../../Config";
import { useNavigate, useLocation } from "react-router-dom";
import { apis } from "../../services/apiService";
import styles from "../../Style/Modules/documentProof.module.css";
import "../../Style/Theme/index.css";
import AlertPopup from "../common/AlertPopup";
const ProofRadios = () => {
  const navigate = useNavigate();
  let location = useLocation();
  const [isError, setIsError] = useState(false);
  const [show, setShow] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [RValue, setRValue] = useState();
  const [Value, setValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [finalErr, setFinalErr] = useState("");
  const handleChange = (e) => {
    setDisabled(false);
    let value = e.target.value;
    setRValue(value);
    if (value && value === "OD") {
      setDisabled(true);
      setShow(true);
    } else {
      setDisabled(false);
      setShow(false);
    }
  };
  const handleInputChange = (e) => {
    setValue(e.target.value);
    if (e?.target?.value) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  let handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const reqData = {
        aid: location?.state?.AppId,
        op: RValue,
        od: Value,
      };
      let resp = await apis.postApi(
        configData.API_URL + "UploadDocument/AddOtherIncomeProof",
        reqData
      );
      let result = await resp.json();
      if (resp?.status === 200) {
        if (RValue === "SL") {
          let data = { AppId: location?.state?.AppId };
          navigate("/upload-shop-certificate", { state: data });
        } else if (RValue === "TL") {
          let data = { AppId: location?.state?.AppId };
          navigate("/upload-trade-license", { state: data });
        } else if (RValue === "OD") {
          let data = { AppId: location?.state?.AppId };
          navigate("/upload-other-documents", { state: data });
        }
      }
    } catch (error) {
      setLoading(false);
      const errorResult = JSON.parse(error?.message);
      setFinalErr(errorResult?.statusMessage);
    }
  };

  const handleClosedFunk = () => {
    setFinalErr("");
  };
  return (
    <form autoComplete="off" onSubmit={handleSubmit}>
      <Box className={styles.documentProof}>
        <RadioGroup name="proof" onChange={handleChange}>
          <Radio value="SL" label="Shop and establishment certificate" />
          <Radio value="TL" label="Trade license" />
          <Radio value="OD" label="Other document with name" />
          {show && (
            <Input
              autoComplete="off"
              onChange={handleInputChange}
              type="text"
              name="documentName"
              label="Name of the document"
            />
          )}
          {show && isError && (
            <Box mt={-2} ml={0}>
              <Typography variant="p" color="subtitle" className="errorMsg_Th">
                Enter valid document name
              </Typography>
            </Box>
          )}
        </RadioGroup>
      </Box>
      {loading && (
        <Backdrop ax="center">
          <LoadingDots />
        </Backdrop>
      )}
      {finalErr && (
        <Backdrop ax="center">
          <AlertPopup finalErr={finalErr} handleClosed={handleClosedFunk} />;
        </Backdrop>
      )}
      <SubmitButton hasNote="No" disabled={disabled} />
    </form>
  );
};

export default ProofRadios;
